import CapchaInput from './capcha-input';

export default CapchaInput;